import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { FileUpload } from "PFComponents/file_upload";
import { useDownloadTextFile } from "PFCore/helpers/use_download_text_file";
import { useResponseErrors } from "PFCore/helpers/use_response_errors";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useImportModalContext } from "../../contexts/import_modal_context";
import css from "./upload_page.module.scss";

type UploadPageProps = {
  data: object;
  url: string;
  disabled?: boolean;
  onSuccess: () => void;
};

export const UploadPage = ({ data, url, disabled, onSuccess }: UploadPageProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "importFiles.upload" });
  const { t: tGeneric } = useTranslation("translation");
  const { csvTemplate } = useImportModalContext();
  const download = useDownloadTextFile();

  const [isError, setIsError] = useState(false);

  const { showGrowl } = useGrowlStoreActions();
  const { getFirstError } = useResponseErrors();

  const handleReset = () => {
    setIsError(false);
  };

  const handleError = (response) => {
    setIsError(true);
    showGrowl({
      message: getFirstError(response) || tGeneric("somethingWentWrong"),
      kind: "error"
    });
  };

  const handleTypeError = () => {
    showGrowl({
      message: t("invalidFileType"),
      kind: "error"
    });
  };

  const handleDownload = () => {
    download("template.csv", csvTemplate!);
  };

  return (
    <FileUpload
      className={css.fileUpload}
      url={url}
      name="csv"
      data={data}
      allowedFileTypes={["csv"]}
      acceptMediaTypes={[".csv"]}
      header={t("uploadNewCSVFile")}
      downloadButtonText={csvTemplate && t("downloadCSVTemplate")}
      hasRemoveButton={false}
      isError={isError}
      disabled={disabled}
      onLoad={onSuccess}
      onError={handleError}
      onTypeError={handleTypeError}
      onDownload={handleDownload}
      onReset={handleReset}
    />
  );
};
